module.exports = __webpack_public_path__ + "img/curv_14_b.b09705cb.jpg";